<template>
  <div class="animated fadeIn">
    <RegistrationsDashboard />
    <MembersDashboard />
  </div>
</template>

<script>
import RegistrationsDashboard from './dashboard/registrations'
import MembersDashboard from './dashboard/members'
export default {
  name: "dashboard",
  components: {
    RegistrationsDashboard,
    MembersDashboard,
  }
};
</script>
